import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div
      className="pulse-state-panel rounded-2xl border border-[#003f28]/10 bg-white p-6 text-center sm:p-8 md:p-10"
      role="alert"
    >
      <h2 className="mb-2 text-lg font-semibold text-[#003f28]">Acceso no disponible</h2>
      <p className="mb-6 text-[#003f28]/80">
        Tu sesión ha caducado o no tienes acceso. Inicia sesión con tu correo corporativo.
      </p>
      <Link
        to="/access"
        className="inline-block rounded-full bg-[#FFA61C] px-6 py-2.5 text-sm font-semibold text-[#003f28] transition hover:bg-[#FF9C1A]"
      >
        Iniciar sesión
      </Link>
    </div>
  );
}
